import { useEffect, useState } from 'react';

/**
 * useNow — a ticking `Date.now()`.
 *
 * Countdowns computed inline during render ("2h 14m left", "12m until
 * auto-destroy") freeze at mount and only move when an unrelated query happens
 * to invalidate. Time-to-auto-destroy is precisely the number a trainee needs to
 * trust, so any component rendering one must derive it from this hook.
 *
 * @param intervalMs tick period. 30s is right for minute-granularity labels;
 *                   pass 1000 for a seconds readout.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(t);
  }, [intervalMs]);
  return now;
}
